export const VISIBILITY_LEVEL = {
  BASIC: 'basic',
  ADVANCED: 'advanced',
  EXPERT: 'expert',
} as const;

export type Level = (typeof VISIBILITY_LEVEL)[keyof typeof VISIBILITY_LEVEL];
